module.exports = __webpack_public_path__ + "img/phone.cbb85fe1.png";